"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Spinner = _interopRequireDefault(require("../../../components/Spinner"));
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SignInForm extends _react.default.Component {
  constructor() {
    super();
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      this.props.onSubmit();
      this.setState({
        loggingIn: true
      });
    });
    _defineProperty(this, "render", () => {
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, this.props.error && !this.state.loggingIn && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert alert-danger",
        role: "alert"
      }, this.props.error.message), this.props.message && /*#__PURE__*/_react.default.createElement("div", {
        className: "alert alert-success",
        role: "alert"
      }, this.props.message), this.state.loggingIn ? /*#__PURE__*/_react.default.createElement(_Spinner.default, null) : null, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "email",
        className: "text-muted text-uppercase"
      }, /*#__PURE__*/_react.default.createElement("small", null, "Email")), /*#__PURE__*/_react.default.createElement("input", {
        type: "email",
        className: "form-control",
        id: "email",
        onChange: this.props.onChange,
        value: this.props.state.email,
        name: "email",
        required: true,
        autoFocus: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "password",
        className: "text-muted text-uppercase"
      }, /*#__PURE__*/_react.default.createElement("small", null, "Password")), /*#__PURE__*/_react.default.createElement(_.PasswordInput, {
        type: "password",
        id: "password",
        name: "password",
        value: this.props.state.password,
        onChange: this.props.onChange,
        required: true
      })), /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: "btn btn-primary mt-4"
      }, "Log in"), /*#__PURE__*/_react.default.createElement("div", {
        className: "d-flex mt-4"
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: "/forgot-password"
      }, "Forgot password?")));
    });
    this.state = {
      loggingIn: false
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error !== this.props.error) {
      this.setState({
        loggingIn: false
      });
    }
  }
}
var _default = exports.default = SignInForm;
module.exports = exports.default;